import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import * as angular from "angular";
import {SiteFiltersType} from "../../../types/site-filters.type";
import * as _ from "lodash";

require('./packages-indicator.scss');
@Component({
  standalone: false,
  selector: 'app-packages-indicator',
  templateUrl: './packages-indicator.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackagesIndicatorComponent implements OnInit, OnChanges {

  @Input() packages: any;
  @Input() maxDisplay: number;
  @Input() isShowFilterByButton: boolean;

  @Output() onFilterByType = new EventEmitter<{ type: string, value: string[] }>();

  public viewPackages: any;
  public extraPackages: any;
  public sitePackageItemsMap: any;
  public packageTypes: string[];
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public isShowActions: boolean = false;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this._initPackages(angular.copy(this.packages));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.packages && !changes.packages.isFirstChange()) {
      this._initPackages(this.packages);
    }
  }

  private _initPackages(packages) {

    if (!this.packages) return;

    this.packageTypes = this.packages.map(p => p.type || p.size);
    this.viewPackages = [];

    if (_.get(packages, 'length')) {

      this.viewPackages = this.maxDisplay ? _.filter(packages, (item, index: number) => {
        return index < this.maxDisplay;
      }) : packages;

      this.extraPackages = packages.slice(this.maxDisplay);

    }
  }

  filterByTypeEvent($event) {
    $event.stopPropagation();
    this.onFilterByType.emit({type: this.siteFiltersType.packagesIds, value: this.packageTypes});
  }

}
